// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ToastContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-unotoastcontainer" */ "./ToastContainer")).then((bundle)=>{
        return {
            default: bundle.ToastContainer
        };
    });
export const LazyToastContainer = /*#__PURE__*/ lazy(ToastContainerLazyLoader);
